import React from 'react';
import { InfoTip } from '../shared/FormKit';

/**
 * The head-count tile used by every L&D session surface
 * (the four boxes match the QR screen's). Lives here so the QR
 * check-in modal and the session detail panel cannot drift apart.
 *
 * Props: label, value, tone ('slate' | 'green' | 'amber'), hint — a small
 * help icon beside the label that shows the one-line definition of what is
 * being counted on hover. With `onClick` the tile doubles as a tab:
 * `active` draws it selected. (A div with the button role rather than a
 * <button>, because the help icon is itself a button.)
 */
// The Walk-Ins tile's hover hint. One copy here so the QR check-in modal and
// the session detail panel say the same thing.
export const SESSION_STAT_HINTS = {
  walkIns: 'People who checked in without being on the expected list.',
};

const STAT_TONES = {
  slate: 'text-slate-900',
  green: 'text-green-700',
  amber: 'text-amber-600',
};

const StatTile = ({ label, value, tone = 'slate', hint, onClick, active = false }) => (
  <div
    role={onClick ? 'button' : undefined}
    tabIndex={onClick ? 0 : undefined}
    aria-pressed={onClick ? active : undefined}
    onClick={onClick}
    onKeyDown={onClick ? (e) => {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick(e); }
    } : undefined}
    className={`border rounded-lg px-3 py-2 bg-white ${
      onClick ? 'cursor-pointer transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500' : ''} ${
      active
        ? 'border-blue-500 ring-1 ring-blue-500 bg-blue-50/40'
        : onClick ? 'border-slate-200 hover:border-blue-400' : 'border-slate-200'}`}
  >
    <p className="text-xs text-slate-500 flex items-center gap-1">
      <span>{label}</span>
      {hint && <InfoTip text={hint} />}
    </p>
    <p className={`text-2xl font-bold mt-0.5 ${STAT_TONES[tone] || STAT_TONES.slate}`}>{value}</p>
  </div>
);

export default StatTile;
